// extracted by mini-css-extract-plugin
export default {"container":"ViewField_container__z+SXf","label":"ViewField_label__bezH3","value":"ViewField_value__ABljU","lg":"ViewField_lg__PgbA4"};